import Icon from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button, Col, message, Modal, Row } from 'antd';
import React, { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { removeFromBlockList } from 'services/api/blockList';
import { buyerNickMask } from 'services/channels/demo';
import { ReactComponent as iconAdd } from '../assets/addToBlockList.svg';
import { useSetConversation, useGetConversationById } from 'hooks/business/lruConversation';

interface Props {
  blacklistId: number;
  buyerNick: string;
  storeId: string;
  blockScope: 1 | 2;
  conversationId: string;
  children?: React.ReactNode;
}

const Container = styled.div`
  .scope-select {
    background-color: var(--fett-border-default);
    padding: 4px;
    display: inline-block;
    .ant-btn {
      color: var(--fett-app-primary-color);
    }
    .ant-btn-text {
      color: var(--fett-text-secondary);
    }
  }
`;

const RemoveFromBlockList = React.memo((props: Props) => {
  const { blacklistId, buyerNick, storeId, blockScope, conversationId, children } = props;
  const setConversation = useSetConversation();
  const getConversationById = useGetConversationById();
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<1 | 2>(blockScope);
  const onClick = () => {
    removeFromBlockList({
      id: blacklistId,
      blacklistScope: value,
      storeId,
    })
      .then(() => {
        const conversation = getConversationById(conversationId);
        if (conversation) {
          setConversation(conversationId, {
            ...conversation,
            blacklistFlag: false,
            blacklistReason: undefined,
            blacklistScope: undefined,
            blacklistId: undefined,
          });
        }
        message.success(t('ViewBlockList.移出成功，买家消息可正常接收'));
        setVisible(false);
      })
      .catch(() => {
        message.success(t('ViewBlockList.移出错误，请稍后重试'));
      });
  };

  return (
    <>
      <Modal
        title={t('ViewBlockList.移除黑名单')}
        visible={visible}
        okText={t('ViewBlockList.确认移出')}
        onCancel={() => setVisible(false)}
        onOk={onClick}
      >
        <Container>
          <Row gutter={[4, 24]} align="middle">
            <Col span={4}>{t('ViewBlockList.买家昵称')}:</Col>
            <Col span={20}>{buyerNickMask(buyerNick)}</Col>
            <Col span={4}>{t('ViewBlockList.移出范围')}:</Col>
            <Col span={20}>
              <div className="scope-select">
                <Button
                  type={value !== 2 ? 'default' : 'text'}
                  onClick={() => {
                    setValue(1);
                  }}
                  disabled={blockScope === 1}
                >
                  {t('ViewBlockList.全部店铺')}
                </Button>
                <Button
                  type={value === 2 ? 'default' : 'text'}
                  onClick={() => {
                    setValue(2);
                  }}
                  disabled={blockScope === 1}
                >
                  {t('ViewBlockList.仅当前店铺')}
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
      <div
        onClick={() => {
          if (blockScope === 1) {
            onClick();
          } else {
            setVisible(true);
          }
        }}
      >
        {children || (
          <>
            <Icon component={iconAdd} />
            {t('ViewBlockList.取消拉黑')}
          </>
        )}
      </div>
    </>
  );
});

export default RemoveFromBlockList;
